import PackagingCertificationService from 'src/modules/packagingCertification/packagingCertificationService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'PACKAGINGCERTIFICATION_VIEW';

const packagingCertificationViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,
  FIND_RESET: `${prefix}_FIND_RESET`,

  reset: () => async (dispatch) => {
    dispatch({
      type: packagingCertificationViewActions.FIND_RESET,
    });
  },

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: packagingCertificationViewActions.FIND_STARTED,
      });

      const record = await PackagingCertificationService.find(id);

      dispatch({
        type: packagingCertificationViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: packagingCertificationViewActions.FIND_ERROR,
      });

      navigateTo('/library/packaging-certification');
    }
  },
};

export default packagingCertificationViewActions;
